export default function getMetaContent(metaName) {
  const metaElement = document.querySelector(`meta[name='${metaName}']`);

  if (metaElement) return metaElement.getAttribute('content');

  return '';
}
